// extracted by mini-css-extract-plugin
module.exports = {"watermark":"StoryblokWatermark_watermark__l8Enl"};